import axios from 'axios';
import { Config } from 'Lib/config';
import Cookies from 'js-cookie';

const config = {
  headers: {
    'Content-Type': 'application/json',
  },
};

axios.defaults.headers.common = {
  'api-key': Config.API_KEY,
};

const API = axios.create({
  baseURL: Config.API_URL,
  config,
});

API.interceptors.request.use((req) => {
  if (Cookies.get('token')) {
    req.headers.Authorization = `Bearer ${Cookies.get('token')}`;
  }
  return req;
});

export default API;
